import { LazyAction, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "TrustedSenders" */ './lazyIndex');
});
export var lazyGetTrustedSendersAndDomains = new LazyAction(lazyModule, function (m) { return m.getTrustedSendersAndDomains; });
export { default as isSenderEmailInTrustedSendersOrDomains, } from './utils/isSenderEmailInTrustedSendersOrDomains';
//# sourceMappingURL=index.js.map